<template>
  <el-drawer title="校正说明" :visible.sync="drawer" customClass="el-drawer-right">
    <el-form label-position="left">
      <el-form-item label="销售单号" label-width="100px">
        {{ formData.orderId }}
      </el-form-item>
      <el-form-item label="药 品 名" label-width="100px">
        {{ formData.drugName }}
      </el-form-item>
      <el-form-item label="药店名称" label-width="100px" v-if="formData.storeName">
        {{ formData.storeName }}
      </el-form-item>
      <el-form-item label="销售时间" label-width="100px">{{ formData.orderTime | formatTime }}</el-form-item>

      <el-form-item label="校正类型" label-width="100px">{{ formData.correctionTypeDesc }}</el-form-item>
      <el-form-item label="校正说明" label-width="100px">{{ formData.correctionRemark }}</el-form-item>
      <el-form-item label="图片" label-width="100px">
        <template>
          <el-image
            :src="item"
            v-for="(item, key) in formData.correctionFileUrlList"
            :key="key"
            :preview-src-list="[item]"
            style="width: 100px; height: 100px; margin-right: 10px"
          ></el-image>
        </template>
      </el-form-item>
      <el-form-item label="校正时间" label-width="100px">{{ formData.correctionTime | formatTime }}</el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import dayjs from 'dayjs';
export default {
  props: {
    correctionTypeCodeMap: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  data() {
    return {
      drawer: false,
      formData: {}
    };
  },
  methods: {
    init(data) {
      this.drawer = true;
      this.formData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer-right {
  width: 520px !important;
  .el-drawer__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 16px 24px;
    margin-bottom: 0;
    span {
      font-size: 16px !important;
      color: #262626;
    }
  }
  .el-drawer__body {
    padding: 24px;
  }
}
</style>
